var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es485.js.map
